define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/query",
	"csi/heading/stateColorResolver",
	"csi/html",
	"csi/html/StateWidget",
	"csi/locale",
	"csi/monitor/_base",
	"csi/xml"
], function(declare,domClass,query,stateColorResolver,html,StateWidget,locale,monitor,xml) {

	return declare(StateWidget, {

		generating: false,

		_processHtml: function(/*csi.def.Context*/ctx, /*DOMNode*/dom) {
			// summary: process each element with a key according to its matching definition
			this.inherited(arguments);

			var node = ctx.getNode();
			var eDraft = query(".draft", dom)[0];
			var eIssued = query(".issued", dom)[0];
			var eClosed = query(".closed", dom)[0];
			var bIssued = false;
			const css = stateColorResolver.getStateCss(node);

			const stateEnumValue = xml.enumGetText(node.State);

			switch (stateEnumValue) {
				case "Draft": domClass.add(eDraft, css); break;
				case "Generating": domClass.add(eIssued, css); bIssued = true; break;
				case "Issued": domClass.add(eIssued, css); bIssued = true; break;
				case "Failed": domClass.add(eIssued, css); bIssued = true; break;
				case "Complete": domClass.add(eClosed, css); break;
			}

			html.text(eDraft, locale.getEnumName("SupplierRequestState:Draft", true));
			html.text(eClosed, locale.getEnumName("SupplierRequestState:Complete", true));
			html.text(eIssued, bIssued ? locale.getEnumName(node.State, true) : locale.getEnumName("SupplierRequestState:Issued", true));
		},

		/**
		 * @override
		 * If Supplier Request is issuing and generating PDFs, refresh state header when finished
		 */
		onViewCreate: function() {
			this.own(monitor.onChangeNode(this.urlRoot, node => {
				if (node && node.State === "SupplierRequestState:Generating") {
					this.generating = true;
				}

				// refresh widget only once when transitioning from generating to issued
				if (this.generating && node && node.State === "SupplierRequestState:Issued") {
					this.generating = false;
					this.refreshWidget();
				}
			}));
		}
	});
});